<template>
    <page>
        <template #title>
            Datenschutzerklärung für die Nutzung der Webanwendung Digit GB (Stand: Oktober 2020)
        </template>

        <template #content>
            <e-typography-heading-2 tag="h2">
                Vorbemerkung
            </e-typography-heading-2>
            <e-typography-body tag="p">
                Als Arbeitgeber sind Sie nach dem Arbeitsschutzgesetz verpflichtet, die mit der Art der Tätigkeit Ihrer Beschäftigten verbundenen Gefährdungen zu ermitteln und wirksame Maßnahmen des Arbeitsschutzes zu entwickeln. Sie bekommen mit der Digit GB ein Assistenzsystem zur Verfügung, mit dem Sie mobil auf der Baustelle, am Arbeitsplatz und im Büro eine Gefährdungsbeurteilung durchführen können. Die Inhalte der Anwendung sollten im Laufe der Zeit stetig erweitert werden.
              </e-typography-body>

            <e-typography-body tag="p">
                Die Digit GB ist eine kostenlose Webanwendung, die Mitgliedsunternehmer der BG BAU bei ihren gesetzlichen Aufgaben im Zusammenhang mit der Erstellung einer Gefährdungsbeurteilung nach dem Arbeitsschutzgesetz unterstützt (nachfolgend „Digit GB“). Unser bisheriges Angebot der „Online Handlungshilfe GB“ möchten wir mit dieser Anwendung noch einmal deutlich verbessern und kundenfreundlicher gestalten. Digit GB ist als Webapplikation auf einer Unterseite von <a href="https://www.bgbau.de" target="_blank">www.bgbau.de</a> erreichbar.
            </e-typography-body>

            <e-typography-heading-2 tag="h2">
                1. Information über die Verarbeitung personenbezogener Daten / Verantwortlicher / Kontaktdaten des Datenschutzbeauftragten
            </e-typography-heading-2>

            <e-typography-body tag="p">
                (1) Im Folgenden informieren wir die betroffenen Personen über die Erhebung personenbezogener Daten bei Nutzung von Digit GB auf unserer Website (<a href="https://www.bgbau.de" target="_blank">www.bgbau.de</a>). Personenbezogene Daten sind alle Daten, die auf eine betroffene Person persönlich bezogen oder beziehbar sind, z. B. Name, Adresse, E-Mail-Adressen, Nutzerverhalten.
            </e-typography-body>

            <e-typography-body tag="p">
                (2) Verantwortlicher für die Webapplikation Digit GB gem. Art. 4 Nr. 7 EU-Datenschutz-Grundverordnung (DSGVO) ist die BG BAU - Berufsgenossenschaft der Bauwirtschaft Körperschaft des öffentlichen Rechts (KdöR), Hildegardstraße 29/30, 10715 Berlin, Telefon: 030 85781-0, Telefax: 0800 6686688-37400, E-Mail: info(at)bgbau.de.
            </e-typography-body>

            <e-typography-body tag="p">
                (3) Unseren Datenschutzbeauftragten erreichen Sie wie folgt:<br>
                BG BAU - Berufsgenossenschaft der Bauwirtschaft<br>
                z. Hd. Datenschutzbeauftragter<br>
                Hildegardstraße 29/30<br>
                10715 Berlin<br>
                E-Mail: datenschutz(at)bgbau.de.
            </e-typography-body>

            <e-typography-body tag="p">
                (4) Bei Ihrer Kontaktaufnahme mit uns per E-Mail oder über ein Kontaktformular werden die von Ihnen mitgeteilten Daten (Ihr Anliegen, Ihre Nachricht, Ihre E-Mail-Adresse, Ihr Name und Ihre Telefonnummer) von uns gespeichert, um Ihre Fragen zu beantworten. Die in diesem Zusammenhang anfallenden Daten löschen wir, nachdem die Speicherung nicht mehr erforderlich ist, oder schränken die Verarbeitung ein, falls gesetzliche Aufbewahrungspflichten bestehen.
            </e-typography-body>

            <e-typography-body tag="p">
                (5) Falls wir für einzelne Funktionen unseres Angebots auf beauftragte Dienstleister zurückgreifen oder Ihre Daten für interne Auswertungen nutzen möchten, werden wir Sie untenstehend im Detail über die jeweiligen Vorgänge informieren. Dabei nennen wir auch die festgelegten Kriterien der Speicherdauer.
            </e-typography-body>

            <e-typography-heading-2 tag="h2">
                2. Erhebung personenbezogener Daten beim Besuch unserer Website
            </e-typography-heading-2>

            <e-typography-body tag="p">
                (1) Bei der bloß informatorischen Nutzung unserer Website <a href="https://www.bgbau.de" target="_blank">www.bgbau.de</a> (einschließlich der Unterseite, auf der die Webapplikation Digit GB genutzt werden kann), also wenn Sie sich nicht registrieren oder uns anderweitig Informationen übermitteln, erheben wir nur die personenbezogenen Daten, die Ihr Browser an unseren Server übermittelt. Wenn Sie diese Website lediglich betrachten möchten, erheben wir die folgenden Daten, die für uns technisch erforderlich sind, um Ihnen unsere Website anzuzeigen und die Stabilität und Sicherheit zu gewährleisten (Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f DSGVO):
            </e-typography-body>

            <e-typography-body tag="p">
                <ul>
                    <li>IP-Adresse </li>
                    <li>Datum und Uhrzeit der Anfrage </li>
                    <li>Zeitzonendifferenz zur Greenwich Mean Time (GMT) </li>
                    <li>Inhalt der Anforderung (konkrete Seite) </li>
                    <li>Zugriffsstatus/HTTP-Statuscode</li>
                    <li>jeweils übertragene Datenmenge </li>
                    <li>Website, von der die Anforderung kommt </li>
                    <li>Browser, Sprache und Version der Browsersoftware </li>
                    <li>Betriebssystem und dessen Oberfläche </li>
                </ul>
            </e-typography-body>

            <e-typography-body tag="p">
                (2) Zusätzlich zu den zuvor genannten Daten werden bei Ihrer Nutzung unserer Website <a href="https://www.bgbau.de" target="_blank">www.bgbau.de</a> sog. Cookies auf Ihrem Rechner gespeichert. Bei Cookies handelt es sich um kleine Textdateien, die auf Ihrer Festplatte dem von Ihnen verwendeten Browser zugeordnet gespeichert werden und durch welche der Stelle, die den Cookie setzt (hier durch uns), bestimmte Informationen zufließen. Cookies können keine Programme ausführen oder Viren auf Ihren Computer übertragen. Sie dienen dazu, das Internetangebot insgesamt nutzerfreundlicher und effektiver zu machen.
            </e-typography-body>

            <e-typography-body tag="p">
                (3) Einsatz von Cookies:
            </e-typography-body>

            <e-typography-body tag="p">
                a) Die Website <a href="https://www.bgbau.de" target="_blank">www.bgbau.de</a> nutzt folgende Arten von Cookies, deren Umfang und Funktionsweise im Folgenden erläutert werden:
            </e-typography-body>

            <e-typography-body tag="p">
                <ul>
                    <li>Transiente Cookies (dazu b) und </li>
                    <li>Persistente Cookies (dazu c). </li>
                    <li>Cookies in Zusammenhang mit Diensten Dritter, wie in dieser Datenschutzerklärung nachfolgend beschrieben. </li>
                </ul>
            </e-typography-body>

            <e-typography-body tag="p">
                b) Transiente Cookies werden automatisiert gelöscht, wenn Sie den Browser schließen. Dazu zählen insbesondere die Session-Cookies. Diese speichern eine sogenannte Session-ID, mit welcher sich verschiedene Anfragen Ihres Browsers der gemeinsamen Sitzung zuordnen lassen. Dadurch kann Ihr Rechner wiedererkannt werden, wenn Sie auf unsere Website zurückkehren. Die Session-Cookies werden gelöscht, wenn Sie sich ausloggen oder den Browser schließen.
            </e-typography-body>

            <e-typography-body tag="p">
                c) Persistente Cookies werden automatisiert nach einer vorgegebenen Dauer gelöscht, die sich je nach Cookie unterscheiden kann. Sie können die Cookies in den Sicherheitseinstellungen Ihres Browsers jederzeit löschen.
            </e-typography-body>

            <e-typography-body tag="p">
                d) Sie können Ihre Browser-Einstellung entsprechend Ihren Wünschen konfigurieren und z. B. die Annahme von Third-Party-Cookies oder allen Cookies ablehnen. Informationen über die Verwaltung und Löschung von Cookies sowie eine entsprechende Anleitung hierzu für die gängigen Browser sind zudem unter <a href="https://www.meine-cookies.org" target="_blank">www.meine-cookies.org</a> abrufbar. Wir weisen Sie jedoch darauf hin, dass Sie dann eventuell nicht alle Funktionen dieser Website nutzen können.
            </e-typography-body>

            <e-typography-body tag="p">
                e) Diese gespeicherten Informationen werden getrennt von eventuell weiter bei uns angegeben Daten gespeichert. Insbesondere werden die Daten der Cookies nicht mit Ihren weiteren Daten, sofern solche übermittelt werden, verknüpft.
            </e-typography-body>

            <e-typography-heading-2 tag="h2">
                3. Registrierung / Verifizierung / Einrichten des Nutzerkontos / Löschung der Zugangsdaten
            </e-typography-heading-2>

            <e-typography-body tag="p">
                (1) Die Nutzung der Webapplikation Digit GB ist erst nach Eröffnung eines persönlichen Zugangs möglich. Für die Registrierung benötigen wir lediglich Ihren Namen, Ihre Benutzerrolle, Ihre E-Mail-Adresse (Pflichtangaben) sowie auf freiwilliger Basis ggf. zusätzlich Ihre Telefonnummer und/oder Mobilfunknummer.
            </e-typography-body>

            <e-typography-body tag="p">
                (2) Nach dem Registrierungsvorgang senden wir Ihnen an die von Ihnen angegebene Adresse eine E-Mail mit einem initialen Passwort zu. In der E-Mail bitten wir Sie um Bestätigung, dass Sie die Registrierung abschließen möchten. Solange Sie dies nicht bestätigen, ist Ihre Registrierung nicht vollständig und Sie können das Service-Angebot nicht nutzen. Alternativ können Sie sich auch schriftlich bei uns melden, um am Test teilzunehmen.
            </e-typography-body>

            <e-typography-body tag="p">
                (3) Mit dem von uns zur Verfügung gestellten Passwort können Sie sich in die Webanwendung einloggen. Wenn Sie unseren Datenschutz- und Nutzungsbedingungen zugestimmt haben, steht Ihnen der Service zur Verfügung. Sie können nun auch – mit deren Einverständnis - weitere Mitarbeiter/Innen Ihres Unternehmens als Nutzer anlegen. Wir empfehlen Ihnen, das initiale Passwort nach erfolgter Registrierung zu ändern.
            </e-typography-body>

            <e-typography-body tag="p">
                (4) Wir speichern Ihre Zugangsdaten - vorbehaltlich vorrangiger gesetzlicher Aufbewahrungspflichten - solange der Benutzer-Account aktiv ist. Sobald Sie den Benutzer-Account vollständig und endgültig löschen, werden auch die entsprechenden Zugangsdaten und die unter dem Account eingepflegten Daten unwiederbringlich gelöscht.
            </e-typography-body>

            <e-typography-heading-2 tag="h2">
                4. Nutzung der Digit GB
            </e-typography-heading-2>

            <e-typography-heading-3 tag="h3">
                4.1 Ausgangslage und Verantwortlichkeiten / Auftragsverarbeitung
            </e-typography-heading-3>

            <e-typography-body tag="p">
                (1) Die Digit GB ist nach den Qualitätsgrundsätzen für Handlungshilfen zur Gefährdungsbeurteilung entsprechend der GDA-Leitlinie aufgebaut.
            </e-typography-body>

            <e-typography-body tag="p">
                (2) Das angemeldete Unternehmen, welches die Datenerfassung in Digit GB vornimmt, ist und bleibt nach den Vorschriften des Arbeitsschutzgesetzes für die Gefährdungsbeurteilung selbst verantwortlich; wir bieten hierfür lediglich eine digitale Handlungshilfe.
            </e-typography-body>

            <e-typography-body tag="p">
                (3) Entsprechendes gilt für die datenschutzrechtliche Verantwortlichkeit des Unternehmens im Hinblick auf die personenbezogenen Daten seiner Mitarbeiter sowie sonstiger betroffener Personen, deren Daten das Unternehmen in die Webapplikation Digit GB einpflegt; auch insoweit ist und bleibt das Unternehmen Verantwortlicher i. S. v. Art. 4 Nr. 7 DSGVO.
            </e-typography-body>

            <e-typography-body tag="p">
                (4) Sofern und soweit zwischen dem angemeldeten Unternehmen und uns ein Vertrag über Auftragsverarbeitung vorliegen sollte, wird eine den Anforderungen des Art. 28 DSGVO entsprechende Vereinbarung über Auftragsverarbeitung geschlossen.
            </e-typography-body>

            <e-typography-heading-3 tag="h3">
                4.2 Dialogfelder und freie Eingabe (Datenerhebung)
            </e-typography-heading-3>

            <e-typography-body tag="p">
                (1) Wenn Sie sich als Unternehmer anmelden, wählen Sie im ersten Schritt zunächst das Gewerk aus. Es gibt 11 Gefährdungsfaktoren, die in einem Dialogsystem mit Antworten "ja", "Nein", "Vielleicht“ oder „in Planung" beantwortet werden können. Außerdem gibt es eine Wirksamkeitskontrolle, mittels derer Sie eine Auflistung erhalten, in welchen Bereichen es noch Defizite gibt. Die Digit GB kommt weitgehend ohne die Erfassung personenbezogener Daten und/oder Geschäftsgeheimnisse im Rahmen der Gefährdungsbeurteilung aus. Vereinzelt ist dies aber möglich.
            </e-typography-body>

            <e-typography-body tag="p">
                (2) Unter der Rubrik „Beschäftigte“ können Sie z. B. (optional) dienstliche Daten (Name, Telefonnummer) von Beschäftigten, denen Sie Pflichten übertragen haben oder auch von der von Ihnen bestellten Fachkraft für Arbeitssicherheit eintragen. Bitte beachten Sie, dass Sie für die Berechtigung zur Eingabe dieser Daten selbst verantwortlich sind. Sorgen Sie bitte dafür, dass diese Personen in die Eingabe dieser Daten eingewilligt haben und auch, dass Geschäftsgeheimnisse anderer Firmen gewahrt bleiben. Sollte eine Person Ihnen gegenüber ihre diesbezügliche Einwilligung widerrufen, sind Sie verpflichtet, die Daten zu dieser Person unverzüglich aus Digit GB zu löschen.
            </e-typography-body>

            <e-typography-heading-3 tag="h3">
                4.3 Hochladen von Bildern
            </e-typography-heading-3>

            <e-typography-body tag="p">
                (1) Über die Digit GB können Sie am Ende jeden Gefährdungsfaktors (optional) Bilder von Gefährdungspunkten zur Dokumentation hochladen.
            </e-typography-body>

            <e-typography-body tag="p">
                (2) Für die Zulässigkeit der Bildaufnahmen (Urheberrecht des Fotografen, Wahrung des Rechts am eigenen Bild, erteilte Einwilligungen u. ä.) sind Sie verantwortlich. Wir gehen davon aus, dass Ihnen sämtliche Rechte zustehen, wenn Sie ein Bild hochladen.
            </e-typography-body>

            <e-typography-body tag="p">
                (3) Wir empfehlen Ihnen dringend, nur solche Bilder in die Digit GB App einzustellen, auf denen keine identifizierbaren Personen oder Geschäftsgeheimnisse anderer Firmen (z.B. Nummernschilder, Firmenautos mit Bezeichnung) zu sehen sind.
            </e-typography-body>

            <e-typography-body tag="p">
                (4) Wir behalten uns vor, Bilder zu löschen, die gegen die vorstehenden Vorgaben verstoßen. Gleiches gilt, wenn von dritter Seite die Löschung eines Bildes wegen etwaiger Rechtsverletzungen verlangt wird.
            </e-typography-body>

            <e-typography-heading-3 tag="h3">
                4.4 Dateneinsicht, Gastzugang und Weitergabe an Dritte
            </e-typography-heading-3>

            <e-typography-body tag="p">
                (1) Die von Ihnen in der Anwendung abgelegten Daten können grundsätzlich nur Sie selbst über den Passwortzugang einsehen und bearbeiten. Mitarbeiter der BG BAU oder sonstige Dritte können die Daten nicht lesen.
            </e-typography-body>

            <e-typography-body tag="p">
                (2) Allerdings ist es möglich, anderen Personen einen Gastzugang zu gewähren und diesen Personen eine beschränkte Sicht auf Ihre Dateneingaben zu ermöglichen, z. B. auch Mitarbeitern der BG BAU, damit diese  dann insoweit ihre Beratungsaufgaben nach § 17 SGB VII (Beratung bzgl. Durchführung der Maßnahmen zur Verhütung von Arbeitsunfällen, Berufskrankheiten, arbeitsbedingten Gesundheitsgefahren) wahrnehmen können. Die Einrichtung des Gastzugangs bedarf aber in jedem Fall Ihres ausdrücklichen Einverständnisses.
            </e-typography-body>

            <e-typography-body tag="p">
                (3) Eine Weitergabe der Daten an Dritte oder eine sonstige Nutzung der Daten durch die BG BAU für andere Zwecke als die hier genannten erfolgt nicht, es sei denn, dies wird in dieser Datenschutzerklärung explizit beschrieben.
            </e-typography-body>

            <e-typography-heading-2 tag="h2">
                5. Schutz der personenbezogenen Daten
            </e-typography-heading-2>

            <e-typography-body tag="p">
                (1) Wir treffen geeignete technische und organisatorische Maßnahmen gemäß den Anforderungen von Art. 32 DSGVO zum Schutz der personenbezogenen Daten der Nutzerin bzw. des Nutzers.
            </e-typography-body>

            <e-typography-body tag="p">
                (2) Alle unsere Mitarbeiterinnen und Mitarbeiter, die mit der Verarbeitung personenbezogener Daten beschäftigt sind, sind auf das Datengeheimnis verpflichtet.
            </e-typography-body>

            <e-typography-body tag="p">
                (3) Personenbezogene Daten der Nutzerin bzw. des Nutzers werden bei der Übermittlung an die Webseite mittels HTTPS verschlüsselt.
            </e-typography-body>

            <e-typography-heading-2 tag="h2">
                6. Unterauftragnehmer und Empfänger personenbezogener Daten
            </e-typography-heading-2>

            <e-typography-body tag="p">
                (1) Wir setzen im Rahmen der Verarbeitung der personenbezogenen Daten Unterauftragnehmer ein und schließen mit diesen Auftragsverarbeitern einen Vertrag gemäß den Anforderungen des Art. 28 DSGVO.
            </e-typography-body>

            <e-typography-body tag="p">
                (2) Als Unterauftragnehmer zum Hosting der Webseite <a href="https://www.bgbau.de" target="_blank">www.bgbau.de</a> einschließlich der Webapplikation Digit GB, die unter einer Subdomain unserer Website erreichbar ist, wird die Port Sol 19 GmbH, Mainz, eingesetzt.
            </e-typography-body>

            <e-typography-body tag="p">
                (3) Das Analyseprogramm Matomo, das auf <a href="https://www.bgbau.de" target="_blank">www.bgbau.de</a> aktiv ist, wird in unserem UV-Rechenzentrum in Deutschland selbst gehostet und dort ebenfalls von der Port Sol 19 GmbH bereitgestellt.
            </e-typography-body>

            <e-typography-body tag="p">
                (4) Eine Übermittlung Ihrer personenbezogenen Daten an andere als die im Rahmen dieser Datenschutzerklärung bereits genannten Unternehmen findet nicht statt.
            </e-typography-body>

            <e-typography-heading-2 tag="h2">
                7. Webtracking und sonstige Dienste Dritter
            </e-typography-heading-2>

            <e-typography-heading-3 tag="h3">
                (1) Einsatz von Matomo
            </e-typography-heading-3>

            <e-typography-body tag="p">
                Auf unserer Website <a href="https://www.bgbau.de" target="_blank">www.bgbau.de</a> werden unter Einsatz der Webanalysedienst-Software Matomo (www.matomo.org), einem Dienst des Anbieters InnoCraft Ltd., 150 Willis St, 6011 Wellington, Neuseeland, („Matomo“) auf Basis unseres berechtigten Interesses an der statistischen Analyse des Nutzerverhaltens zu Optimierungs- und Marketingzwecken gemäß Art. 6 Abs. 1 lit. f DSGVO Daten gesammelt und gespeichert. Aus diesen Daten können zum selben Zweck pseudonymisierte Nutzungsprofile erstellt und ausgewertet werden. Die mit der Matomo-Technologie erhobenen Daten (einschließlich Ihrer pseudonymisierten IP-Adresse) werden auf unseren Servern verarbeitet. Matomo wurde auf dem Server der Port Sol 19 GmbH in Deutschland installiert und speichert Daten auch nur auf diesem Server. Eine Zusammenführung mit anderen Daten der BG BAU findet nicht statt. Die dadurch erzeugten Informationen im pseudonymen Nutzerprofil werden nicht dazu benutzt, die Besucherin bzw. den Besucher dieser Website persönlich zu identifizieren und nicht mit personenbezogenen Daten über den Träger des Pseudonyms zusammengeführt.
            </e-typography-body>

            <e-typography-body tag="p">
                Die vorstehenden Informationen sind nur relevant, sofern Sie vor dem Besuch der Subdomain, auf der Digit GB erreichbar ist, unsere Hauptseite unter www.bgbau.de besucht haben.
            </e-typography-body>

            <e-typography-heading-3 tag="h3">
                (2) Einsatz von YouTube
            </e-typography-heading-3>

            <e-typography-body tag="p">
                Wir binden auf unserer Hauptseite <a href="https://www.bgbau.de" target="_blank">www.bgbau.de</a> Videos der Plattform “YouTube” des Anbieters Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, ein.
            </e-typography-body>

            <e-typography-body tag="p">
                Datenschutzerklärung des Drittanbieters: <a href="https://www.google.com/policies/privacy/" target="_blank">https://www.google.com/policies/privacy/</a>.
            </e-typography-body>

            <e-typography-body tag="p">
                Wir haben YouTube-Videos in unser Online-Angebot eingebunden, die auf <a href="http://www.youtube.com" target="_blank">http://www.youtube.com</a> gespeichert sind und von unserer Website aus direkt abspielbar sind. Diese Videos haben wir im sog. „erweiterten Datenschutz-Modus“ eingebunden (vgl. hierzu <a href="https://www.heise.de/ct/ausgabe/2016-1-YouTube-Videos-datenschutzkonform-einbetten-3046316.html" target="_blank">https://www.heise.de/ct/ausgabe/2016-1-YouTube-Videos-datenschutzkonform-einbetten-3046316.html</a>). So stellen wir sicher, dass keine personenbezogenen Daten an YouTube übertragen werden, wenn Sie unsere Website besuchen, ohne ein YouTube-Video abzuspielen. Erst wenn Sie ein Video abspielen, werden Daten übertragen. Dabei wird dem YouTube-Server mitgeteilt, welche spezielle Seite unserer Internetpräsenz von Ihnen besucht wurde. Sollten Sie gleichzeitig in Ihrem YouTube-Account eingeloggt sein, würden Sie es YouTube ermöglichen, Ihr Surfverhalten direkt Ihrem persönlichen Profil zuzuordnen. Wenn Sie diese Möglichkeit der Zuordnung nicht wünschen, sollten Sie sich vorher aus Ihrem Account ausloggen.
            </e-typography-body>

            <e-typography-body tag="p">
                Opt-Out-Möglichkeit: <a href="https://adssettings.google.com/authenticated" target="_blank">https://adssettings.google.com/authenticated</a>.
            </e-typography-body>

            <e-typography-body tag="p">
                Die vorstehenden Informationen sind nur relevant, sofern Sie vor dem Besuch der Subdomain, auf der Digit GB erreichbar ist, unsere Hauptseite unter <a href="https://www.bgbau.de" target="_blank">www.bgbau.de</a> besucht haben.
            </e-typography-body>

            <e-typography-heading-3 tag="h3">
                (3) Einsatz von Google Maps
            </e-typography-heading-3>

            <e-typography-body tag="p">
                a) Die Website <a href="https://www.bgbau.de" target="_blank">www.bgbau.de</a> nutzt über eine API den Kartendienst Google Maps. Anbieter ist die Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA (nachfolgend “Google”).
            </e-typography-body>

            <e-typography-body tag="p">
                Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP-Adresse zu speichern. Diese Informationen werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf diese Datenübertragung.
            </e-typography-body>

            <e-typography-body tag="p">
                Die Nutzung von Google Maps erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote und an einer leichten Auffindbarkeit der von uns auf der Website angegebenen Orte. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.
            </e-typography-body>

            <e-typography-body tag="p">
                Nähere Informationen über den Umfang, die Rechtsgrundlage und den Zweck der Datenverarbeitung durch Google sowie die Speicherdauer und Widerspruchs- und Beseitigungsmöglichkeit können Sie den Google-Datenschutzhinweisen unter <a href="https://policies.google.com/privacy" target="_blank">https://policies.google.com/privacy</a> entnehmen. Dort können Sie im Datenschutzcenter auch Ihre persönlichen Datenschutz-Einstellungen verändern.
            </e-typography-body>

            <e-typography-body tag="p">
                Ausführliche Anleitungen zur Verwaltung der eigenen Daten im Zusammenhang mit Google-Produkten finden Sie hier: <a href="https://myaccount.google.com/intro/privacycheckup" target="_blank">https://myaccount.google.com/intro/privacycheckup</a>.
            </e-typography-body>

            <e-typography-body tag="p">
                Die vorstehenden Informationen sind für Sie nur relevant, sofern Sie vor dem Besuch der Subdomain, auf der Digit GB erreichbar ist, unsere Hauptseite unter <a href="https://www.bgbau.de" target="_blank">www.bgbau.de</a> besucht haben.
            </e-typography-body>

            <e-typography-body tag="p">
                b) Allerdings wird auch im Rahmen der Gefährdungsbeurteilung innerhalb der Webapplikation Digit GB Google Maps (Anbieterinformation s. o.) eingesetzt, und zwar zur (optionalen) Geolokalisierung („Standort ermitteln“) von Arbeitsstätten, die von Ihnen angelegt werden können. Die via Google Maps im Einzelfall ermittelten Standortdaten werden sodann in Form des jeweiligen Längen- und Breitengrades in die Erfassung der Arbeitsstätte mit aufgenommen.
            </e-typography-body>

            <e-typography-body tag="p">
                Wir weisen in diesem Zusammenhang vorsorglich darauf hin, dass insbesondere bei einer mobilen Nutzung der Webapplikation Digit GB auf diese Weise auch gleichzeitig die Standortdaten des Nutzers gespeichert werden können. Wenn der Nutzer dies nicht möchte, sollte von der Geolokalisierung der Arbeitsstätte über Google Maps im Einzelfall Abstand genommen und stattdessen die Anschrift der Arbeitsstätte manuell erfasst werden. Rechtsgrundlage für die Nutzung der Standortdaten des Nutzers ist Art. 6 Abs. 1 lit. a DSGVO.
            </e-typography-body>

            <e-typography-heading-2 tag="h2">
                8. Rechtsgrundlagen
            </e-typography-heading-2>

            <e-typography-body tag="p">
                Nach Maßgabe des Art. 13 DSGVO teilen wir Ihnen die Rechtsgrundlagen unserer Datenverarbeitungen mit:
            </e-typography-body>

            <e-typography-body tag="p">
                (1) Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der betroffenen Person einholen, dient Art. 6 Abs. 1 lit. a DSGVO als Rechtsgrundlage.
            </e-typography-body>

            <e-typography-body tag="p">
                (2) Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich sind.
            </e-typography-body>

            <e-typography-body tag="p">
                (3) Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen Verpflichtung erforderlich ist, der wir unterliegen, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage.
            </e-typography-body>

            <e-typography-body tag="p">
                (4) Rechtsgrundlage für die vorübergehende Speicherung der Daten und der Logfiles ist Art. 6 Abs. 1 lit. f DSGVO.
            </e-typography-body>

            <e-typography-body tag="p">
                (5) Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung technisch notweniger Cookies ist Art. 6 Abs. 1 lit. f DSGVO. Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung von Cookies zu Analysezwecken ist Art. 6 Abs. 1 lit. f DSGVO bzw. Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
            </e-typography-body>

            <e-typography-body tag="p">
                (6) Ist die Verarbeitung zur Wahrung eines berechtigten Interesses von uns oder eines Dritten erforderlich und überwiegen die Interessen, Grundrechte und Grundfreiheiten des Betroffenen das erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage für die Verarbeitung.
            </e-typography-body>

            <e-typography-heading-2 tag="h2">
                9. Rechte betroffener Personen / Beschwerderecht / Aufsichtsbehörde
            </e-typography-heading-2>

            <e-typography-body tag="p">
                (1) Dem Nutzer bzw. der Nutzerin und sonstigen betroffenen Personen stehen in Bezug auf deren personenbezogene Daten folgende Rechte uns gegenüber zu:
            </e-typography-body>

            <e-typography-body tag="p">
                <ul>
                    <li>Recht auf Auskunft über die betreffenden personenbezogenen Daten (Art. 15 DSGVO)</li>
                    <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
                    <li>Recht auf Löschung (Art. 17 DSGVO)</li>
                    <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                    <li>Widerspruchsrecht gegen die Verarbeitung, falls die Datenverarbeitung aufgrund von Art. 6 Abs. 1 lit. e oder lit. f DSGVO erfolgt (Art. 21 DSGVO); siehe hierzu auch der nachfolgende Hinweis auf das Widerspruchsrecht nach Art. 21 DSGVO</li>
                    <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
                    <li>Recht, eine erteilte Einwilligung jederzeit zu widerrufen, ohne dass die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung berührt wird, wenn die Datenverarbeitung auf einer Einwilligung nach Art. 6 Abs. 1 lit. a oder Artikel 9 Abs. 2 lit. a DSGVO beruht</li>
                </ul>
            </e-typography-body>

            <e-typography-body tag="p">
                (2) Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren (Art. 77 DSGVO).
            </e-typography-body>

            <e-typography-body tag="p">
                (3) Die für uns zuständige Datenschutzaufsichtsbehörde, bei der eine Beschwerde über eine Verletzung von Datenschutzrecht eingereicht werden kann, ist:
            </e-typography-body>

            <e-typography-body tag="p">
                Der oder die Bundesbeauftragte für den Datenschutz und die Informationsfreiheit <br/>
                Graurheindorfer Str. 153<br/>
                53117 Bonn<br/>
                Telefon: 0228 997799-0<br/>
                Fax: 0228 997799-5550<br/>
                E-Mail: poststelle(at)bfdi.bund.de
            </e-typography-body>

            <e-typography-heading-2 tag="h2">
                10. Keine automatisierte Entscheidungsfindung / kein Profiling
            </e-typography-heading-2>

            <e-typography-body tag="p">
                Wir nehmen keine automatisierte Entscheidungsfindung und kein Profiling vor.
            </e-typography-body>

            <div class="static-privacy-policy__box">
                <e-typography-heading-2 tag="h2">
                    11. Hinweis auf das Widerspruchsrecht gemäß Art. 21 DSGVO
                </e-typography-heading-2>

                <br/>

                <e-typography-body tag="p">
                    (1) Widerspruchsrecht aufgrund der besonderen Situation
                </e-typography-body>

                <e-typography-body tag="p">
                    Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten, die aufgrund von Art. 6 Abs. 1 lit. e (öffentliche Sicherheit) oder f (Datenverarbeitung auf der Grundlage einer Interessenabwägung) DSGVO erfolgt, Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmungen gestütztes Profiling. Wir verarbeiten die personenbezogenen Daten nicht mehr, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
                </e-typography-body>

                <e-typography-body tag="p">
                    (2) Widerspruchsrecht bei Direktwerbung
                </e-typography-body>

                <e-typography-body tag="p">
                    Falls wir personenbezogene Daten von Ihnen verarbeiten, um Direktwerbung zu betreiben, so haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung Sie betreffender personenbezogener Daten zum Zwecke derartiger Werbung einzulegen; dies gilt auch für das Profiling, soweit es mit solcher Direktwerbung in Verbindung steht. Widersprechen Sie der Verarbeitung für Zwecke der Direktwerbung, so werden die personenbezogenen Daten nicht mehr für diese Zwecke verarbeitet.
                </e-typography-body>

                <e-typography-body tag="p">
                    (3) Ausübung des Widerspruchsrechts
                </e-typography-body>

                <e-typography-body tag="p">
                    Das Widerspruchsrecht kann formlos ausgeübt werden, etwa per Post an BG BAU - Berufsgenossenschaft der Bauwirtschaft Körperschaft des öffentlichen Rechts (KdöR), Hildegardstraße 29/30, 10715 Berlin, oder per E-Mail an info(at)bgbau.de.
                </e-typography-body>
            </div>

            <e-typography-heading-2 tag="h2">
                12. Aktualisierung dieser Datenschutzerklärung
            </e-typography-heading-2>

            <e-typography-body tag="p">
                Von Zeit zu Zeit ist es erforderlich, den Inhalt der vorliegenden Datenschutzerklärung anzupassen. Wir behalten uns daher vor, diese jederzeit zu ändern. Wir werden die geänderte Version der Datenschutzhinweise registrierten Nutzerinnen und Nutzern vor Inkrafttreten per E-Mail übermitteln und an derselben Stelle wie die vorliegende Datenschutzerklärung veröffentlichen.
            </e-typography-body>



            <e-typography-body tag="div">
                <template v-if="hasCookie">
                    <h3>Cookie-Richtlinien von CookieFirst.com</h3>
                    <div v-html="cookieFirstContent">{{cookieFirstContent}}</div>
                    <p>
                        Diese Cookie-Richtlinie wurde erstellt und aktualisiert von <a href="https://cookiefirst.com" target="_blank">CookieFirst.com</a>.
                    </p>
                </template>
            </e-typography-body>

        </template>
    </page>
</template>

<script>
    import Page from "@pages/templates/page";
    import ETypographyBody from "../../elements/typography/e-typography-body";
    import ETypographyHeading3 from "../../elements/typography/e-typography-heading-3";

    export default {
        name: "static-privacy-policy",
        components: {Page},
        data: () => ({
            hasCookie: false,
            cookieFirstContent: null
        }),
        methods: {
            hasCookieFirst: function hasCookieFirst() {
                return new Promise(r => {
                    let count = 0;
                    let interval = setInterval(function () {
                        count++;
                        if (window.CookieFirst || count > 10) {
                            clearInterval(interval)
                            if (window.CookieFirst) {
                                r(true)
                            }
                        }
                        r(false)
                    }, 1000);
                })
            },
            async waitForCookieFirst() {
                await this.hasCookieFirst();
                if (typeof window.CookieFirst === "object") {
                    this.hasCookie = true;
                }
                this.cookieFirstContent = document.querySelector("#cookiefirst-source").innerHTML;
                this.$forceUpdate();
            }
        },
        mounted: function() {
            this.waitForCookieFirst();
        },
        metaInfo() {
            return {
                title: this.$t('pages.static.privacy-policy.meta.title')
            }
        },

    }
</script>

<style lang="scss" scoped>
    .static-privacy-policy {
        &__box {
            border: 2px solid black;
            padding: 1rem;
            margin-bottom: 1rem;

            .e-typography-body {
                font-weight: bold;
            }
        }
        li {
            font-size: 2rem;
        }
    }


    a:hover {
        text-decoration: underline;
    }
</style>
